module.exports = __webpack_public_path__ + "static/jiva1-362cf1262d77cfba7e71edf763503edd.png";